<template>
    <div class="ProviderProfile" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="paper">
                <div class="row">
                    <div class="col col-md-10">
                        <h1><span>{{ RecordData.FullName }}</span></h1>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col">
                        <div class="record-tabs">
                            <span class="d-none d-sm-block">
                                <b-nav>
                                    <div v-for="pane in Panes">
                                        <b-nav-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-nav-item>
                                    </div>
                                </b-nav>
                            </span>
                            <b-nav>
                                <span class="d-sm-none">
                                    <b-nav-item-dropdown :text=changeDropdownName id="mobileDropdown">
                                        <div v-for="pane in Panes">
                                            <b-dropdown-item v-on:click="ChangePaneShown(pane.name)" v-bind:class="{ active: PaneShown == pane.name }">{{pane.name}}</b-dropdown-item>
                                        </div>
                                    </b-nav-item-dropdown>
                                </span>
                            </b-nav>
                        </div>
                        <div class="tab-content">
                            <div v-if="PaneShown == 'Information'">
                                <ProviderInformation :record="RecordData" />
                            </div>
                            <div v-if="PaneShown == 'Billing Roles'">
                                <BillingRoles :employee-id="RecordData.Id" />
                            </div>
                            <div v-if="PaneShown == 'Provider File'">
                                <CaseFile chart-type="Employee" :chart-record-id="RecordData.Id" sub-program-id="mentalhealth" />
                            </div>
                            <div v-if="PaneShown == 'New Document'">
                                <NewDocument :chart-record-id="RecordData.Id" :form-memberships="EmployeeFormMemberships" />
                            </div>
                            <div v-if="PaneShown == 'Document Ques'">
                                <DocumentListing :employee-id="RecordData.Id" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    //import components
    import BillingRoles from './BillingRoles';
    import CaseFile from "../../../Core/RecordComponents/CaseFile.vue";
    import NewDocument from "../../../Core/RecordComponents/NewDocument.vue";
    import ProviderInformation from "./ProviderInformation.vue";
    import DocumentListing from "../../../Core/ItemEditors/DocumentListing.vue";
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        name: "ProviderProfile",
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                console.log(chartID);
                console.log("profile event heard... " + vm.ChartID);
                if (chartID.toLowerCase() == vm.ChartID.toLowerCase()) {
                    vm.UpdateChartData(false);
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        data: function () {
            return {
                PaneShown: "Information",
                Panes: [
                    { name: 'Information' },
                    { name: 'Billing Roles' },
                    { name: 'Provider File' },
                    { name: 'New Document' },
                    { name: 'Document Ques' }
                ],
                RecordData: {},
                EmployeeFormMemberships: [],
            };
        },
        methods: {
            UpdateChartData(loadIndicator = true) {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Billing/ProviderProfile/" + this.ChartID, {}, this.UpdateChartDataSuccess, () => { }, loadIndicator);
            },
            UpdateChartDataSuccess(response) {
                this.RecordData = response.data.data;
            },
            GetFormMemberships() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetFormMembershipsForSubProgram", { SubProgramID: "12E83DA9-E178-4DB2-9077-6097F277443A", ChartType: "Employee" }, this.GetFormMembershipsSuccess, () => { }, false);
            },
            GetFormMembershipsSuccess(response) {
                this.EmployeeFormMemberships = response.data.data;
            },

            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
            
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            ProviderInformation,
            BillingRoles,
            CaseFile,
            NewDocument,
            DocumentListing
        },
        mounted() {
            this.UpdateChartData();
            this.GetFormMemberships();
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
            ChartID: function () {
                return this.$route.params.Id;
            }
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }

    @media only screen and (max-width: 576px) {
        h4 {
            font-size: 1em;
        }

        h1 {
            font-size: 1.5em;
        }
    }

    li a {
        color: black !important;
    }

    li.active a {
        color: black !important;
    }
</style>